import { createFileRoute } from "@tanstack/react-router"
import type React from "react"

import { Stack } from "@chakra-ui/react"
import { useEffect } from "react"
import PaymentSuccess from "../components/PaymentSuccess"
import PaymentSuccessParams from "../components/PaymentSuccess"

import useFrame from "../hooks/useFrame"

interface PaymentSuccessParams {
  session_id: string
}

const PaymentSuccessPage: React.FC = () => {
  const { containerRef, sendHeight } = useFrame()

  const session_id = Route.useSearch({
    select: (search) => search.session_id ?? "",
  })
  useEffect(() => {
    sendHeight()
  }, [sendHeight])

  return (
    <>
      <Stack ref={containerRef}>
        <PaymentSuccess session_id={session_id} />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/payment-success")({
  component: PaymentSuccessPage,
  validateSearch: (search: Record<string, unknown>): PaymentSuccessParams => {
    return {
      session_id: (search.session_id as string) || "",
    }
  },
})
